import React, { useState, useEffect } from 'react';
import { makeStyles } from "@mui/styles";
import { Box, Typography, Stepper, Step, StepLabel, useMediaQuery } from "@mui/material";
import { ResidentpageState } from '../../ResidentpageState';

const steps = ['Property Search', 'Select Property', 'Name Search', 'Select Resident'];

const useStyles = makeStyles({
  stepperContainer: {
    paddingTop: '87px', 
    position: 'absolute', 
    top: 0, 
    width: '100%',
    minWidth: '340px'
  },
  stepper: {
    width: '100%',
    '& .MuiStepLabel-root': {
      display: 'flex',
      flexDirection: 'column-reverse !important',
      marginTop: '-65px',
    },
    '& .MuiStepLabel-label': {
      display: 'flex',
      justifyContent: 'center',
    },
    '& .MuiStepLabel-labelContainer': {
      marginBottom: '9px',
    },
    '& .MuiStepConnector-root': {
      top: '15px',
    },
    '& .MuiStepIcon-root': {
      color: '#F1F0F5',
      width: '29px',
      height: '29px',
    },
    '& .MuiStepIcon-root.Mui-completed': {
      color: '#39DB8D',
    },
    '& .MuiStepIcon-root .MuiStepIcon-text': {
      fill: '#14142B',
      fontWeight: '600'
    },
    '& .MuiStepIcon-root.Mui-active': {
      color: '#39DB8D'
    },
    '& .MuiStepIcon-root.Mui-active .MuiStepIcon-text': {
      fill: '#fff'
    },
  },
  text: {
    fontFamily: 'Work Sans !important',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px !important',
    lineHeight: '21px !important',
    maxWidth: '80px',
    color: '#14142B'
  }
});

interface StepperProp {
  pageState: ResidentpageState
}

export default function ResidentStepper(props: StepperProp) {
  const classes = useStyles();
  const matchesMobile = useMediaQuery("(max-width:600px)");

  const [activeStep, setActiveStep] = useState(0);
  useEffect(() => {
    if (props.pageState === ResidentpageState.SearchPropertiesByAddress) {
      setActiveStep(0);
    } else if (props.pageState === ResidentpageState.SelectProperty) {
      setActiveStep(1);
    } else if (props.pageState === ResidentpageState.SearchResidentsByPuuidAndName) {
      setActiveStep(2);
    } else if (props.pageState === ResidentpageState.SelectResident) {
      setActiveStep(3);
    }
  }, [props.pageState])

  return (
    <Box className={classes.stepperContainer} sx={{ display: matchesMobile ? 'none': 'block' }}>
      <Stepper alternativeLabel activeStep={activeStep} classes={{ root: classes.stepper }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel sx={{ display: 'flex', justifyContent: 'center' }}>
              <Typography className={classes.text}>{label}</Typography>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
